import { HttpResult } from "widgets-for-react";
import { ApiResult } from "../../../custom_api/api";
import * as DrupalModel from "../../../custom_models/drupal"
import { defaultGetOptions, handle } from "../../../custom_api/api_utils";

// export const getAllDrupalLocations: () 
//   => Promise<ApiResult<DrupalModel.Location[]>> = () =>
//       get(`${drupalUrl}/api/locations/all`);

const drupalUrl = "/api/drupal";

export const fetchBranchLocations = async (): Promise<HttpResult<DrupalModel.Location[]>> => {
    const res = await fetch(`${drupalUrl}/api/locations/all`)
    const temp = await handle<DrupalModel.Location[]>(res)
    if (temp.kind != 'result') return (temp as HttpResult<DrupalModel.Location[]>)
    return { ...temp, value: temp.value }
}